import { StorageBucketConfig } from '../models/media'
const CDN = 'shiawan-image.oss-cn-shanghai.aliyuncs.com'

export const OssConfig = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAIQaBzBEQ5lLwt',
  secretAccessKey: '5p6IZrbLFoNLs0iSbcABOwYuVyckGc',
  apiVersion: '2013-10-15',
  sku: <StorageBucketConfig> {
    region: 'oss-cn-shanghai',
    bucket: 'shiawan-image',
    folder: 'sku',
    domain: CDN
  },
  static: <StorageBucketConfig> {
    region: 'oss-cn-shanghai',
    bucket: 'shiawan-image',
    folder: 'static',
    domain: CDN
  },
  receipt: <StorageBucketConfig> {
    region: 'oss-cn-shanghai',
    bucket: 'shiawan-image',
    folder: 'receipts',
    domain: CDN
  },
  todo: <StorageBucketConfig> {
    region: 'oss-cn-shanghai',
    bucket: 'shiawan-image',
    folder: 'todo',
    domain: CDN
  }
}



// WEBPACK FOOTER //
// ./src/app/config/oss.config.ts